import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var optedInValue = '1';
/**
 * Name of the Tealium cookie consent
 */

var cookieName = 'CONSENTMGR';
/**
 * Name of the Optanon cookie consent
 */

var optanonCookieName = 'OptanonConsent';
/**
 * Name of the Tealium cookie consent categories
 */

var categories = {
  performance: 'c1:',
  marketing: 'c3:'
};
/**
 * Name of the Optanon cookie consent categories
 */

var optanonCategories = {
  performance: '2',
  functional: '3',
  marketing: '4'
};
/**
 * Get value of consent cookie
 * @param {string} cookies list of cookies
 * @param {string} cookieName name of the consent cookie based on brand, defaults to 'CONSENTMGR'
 * @returns {string} consent cookie value
 */

var getConsentCookieValue = function getConsentCookieValue(cookies) {
  var consentCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cookieName;
  var newConsentCookie = cookies === null || cookies === void 0 ? void 0 : cookies.split(';').filter(function (cookie) {
    return cookie.trim().startsWith("".concat(consentCookie, "="));
  });
  if (!(newConsentCookie !== null && newConsentCookie !== void 0 && newConsentCookie.length)) return ''; // Get the full value after the first = sign, handling values that contain = characters

  var cookieString = newConsentCookie[0].trim();
  var equalIndex = cookieString.indexOf('=');
  return equalIndex !== -1 ? cookieString.substring(equalIndex + 1) : '';
};
/**
 * Get relevant consent section (e.g. c1 = performance, c3 = marketing) in cookie value
 * @param {string} cookieValue consent cookie value
 * @param {string} category cookie consent category name
 * @returns {array} cookie consent category section (name and value e.g 'c1:1')
 *
 * Example cookie value: 'c1:1|c2:0|c3:1|c4:0|c5:0|c6:0|c7:0|c8:0|c9:0|c10:0|c11:0|c12:0|c13:0|c14:0|c15:0|ts:1575020721807|consent:true'
 */


var getCategorySection = function getCategorySection(cookieValue, category) {
  return decodeURI(cookieValue).split('|').filter(function (section) {
    return section.trim().startsWith(categories[category]);
  });
};
/**
 * Parse Optanon cookie value to get groups
 * @param {string} cookieValue Optanon consent cookie value
 * @returns {Object} parsed groups object
 *
 * Example cookie value: 'isGpcEnabled=0&datestamp=Thu+Jun+26+2025+11%3A52%3A51+GMT%2B0100+(British+Summer+Time)&version=202505.2.0&browserGpcFlag=0&isIABGlobal=false&hosts=&genVendors=&consentId=b6a61dc9-bc88-4e5e-9e45-2d6fb7be11e8&interactionCount=1&isAnonUser=1&landingPath=NotLandingPage&groups=1%3A1%2C2%3A0%2C3%3A0%2C4%3A0%2CV2STACK42%3A1&intType=6'
 */


var parseOptanonGroups = function parseOptanonGroups(cookieValue) {
  if (!cookieValue) return null;
  var decodedValue = decodeURIComponent(cookieValue);
  var groupsRegex = /groups=([^&]+)/;
  var groupsMatch = groupsRegex.exec(decodedValue);
  if (!groupsMatch) return null;
  var groupsString = groupsMatch[1]; // Decode the groups string as well since it may be double-encoded

  var decodedGroupsString = decodeURIComponent(groupsString);
  var groups = {};
  decodedGroupsString.split(',').forEach(function (group) {
    var _group$split = group.split(':'),
        _group$split2 = _slicedToArray(_group$split, 2),
        id = _group$split2[0],
        value = _group$split2[1];

    if (id && value !== undefined) {
      groups[id] = value;
    }
  });
  return groups;
};
/**
 * Check if user has opted in for an Optanon category
 * @param {string} cookieValue Optanon consent cookie value
 * @param {string} category cookie consent category name (performance, functional, marketing)
 * @returns {boolean} true if opted in / false if not opted in
 */


var hasOptanonOptedIn = function hasOptanonOptedIn(cookieValue, category) {
  if (!cookieValue || !optanonCategories[category]) return false;
  var groups = parseOptanonGroups(cookieValue);
  if (!groups) return false;
  var categoryId = optanonCategories[category];
  return groups[categoryId] === optedInValue;
};
/**
 * Check if Optanon cookie exists
 * @param {string} cookies list of cookies
 * @returns {boolean} true if Optanon cookie exists
 */


var hasOptanonCookie = function hasOptanonCookie(cookies) {
  return !!(cookies !== null && cookies !== void 0 && cookies.includes("".concat(optanonCookieName, "=")));
};
/**
 * Check if user has opted in for a category
 * @param {array} categorySection cookie consent category section (Example category section: 'c1:1')
 * @returns {boolean} true if opted in / false if not opted in
 */


var hasOptedIn = function hasOptedIn(categorySection) {
  if (!categorySection) return false;
  var consentValue = categorySection.split(':')[1];
  return consentValue === optedInValue;
};

export default {
  cookieName: cookieName,
  optanonCookieName: optanonCookieName,
  categories: categories,
  optanonCategories: optanonCategories,
  getConsentCookieValue: getConsentCookieValue,
  getCategorySection: getCategorySection,
  hasOptedIn: hasOptedIn,
  parseOptanonGroups: parseOptanonGroups,
  hasOptanonOptedIn: hasOptanonOptedIn,
  hasOptanonCookie: hasOptanonCookie
};